/* How the Passport list is ordered.

   "Newest" and "Acquired" are deliberately different sorts. created_at is when
   the item entered the Passport and is never editable; date_added is the
   purchase date the collector types into the wizard, which can be decades
   earlier. Sorting a vintage pair bought last week by either one gives a
   different — and equally correct — answer. */

export const SORT_OPTIONS = [
  { key: "newest", label: "Newest", note: "Most recently added to your Passport" },
  { key: "acquired", label: "Acquired", note: "By the date you got it, newest first" },
  { key: "az", label: "A–Z", note: "Alphabetical by brand, then model" },
  { key: "value", label: "Value", note: "Highest estimated value first" },
];

export const DEFAULT_SORT = "newest";

const name = (i) => `${i.brand} ${i.model}`.trim().toLowerCase();

/* Every comparator falls back to the name. Without it, items that tie — three
   pairs bought the same day, two at the same value — could come back in a
   different order on each render, and a list that reshuffles under a thumb is
   worse than one sorted imperfectly. */
const byName = (a, b) => name(a).localeCompare(name(b));

/** Newest first, with undated items last rather than pretending they're oldest. */
function newestFirst(key) {
  return (a, b) => {
    const av = a[key] || "";
    const bv = b[key] || "";
    if (av === bv) return byName(a, b);
    if (!av) return 1;
    if (!bv) return -1;
    return av < bv ? 1 : -1;
  };
}

const COMPARATORS = {
  newest: newestFirst("createdAt"),
  acquired: newestFirst("dateAdded"),
  az: byName,
  value: (a, b) => (b.value - a.value) || byName(a, b),
};

/** Returns a new array; never sorts the caller's list in place. */
export function sortItems(items, key) {
  return [...items].sort(COMPARATORS[key] || COMPARATORS[DEFAULT_SORT]);
}
